import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=1d712d1c&scoped=true"
import script from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDeleteDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d712d1c",
  null
  
)

export default component.exports